export const DEFAULT = 'default';
export const AUTH = 'auth';
